import { render, staticRenderFns } from "./basic-info.vue?vue&type=template&id=7f79df5b&scoped=true"
import script from "./basic-info.vue?vue&type=script&lang=js"
export * from "./basic-info.vue?vue&type=script&lang=js"
import style0 from "./basic-info.vue?vue&type=style&index=0&id=7f79df5b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f79df5b",
  null
  
)

export default component.exports